import { useCallback, useState } from "react";
import { submitCaresReport } from "services/caresService";
import { CaresSubmitPayload } from "../types";

export const useCaresSubmit = () => {
  const [submitting, setSubmitting] = useState(false);

  const submit = useCallback(async (payload: CaresSubmitPayload) => {
    setSubmitting(true);
    try {
      return await submitCaresReport(payload);
    } finally {
      setSubmitting(false);
    }
  }, []);

  return { submit, submitting };
};
